import { createFileRoute } from '@tanstack/react-router'
import { Email } from '@/components/settings-route/multi-channel/email/index.jsx'

export const Route = createFileRoute('/_auth/settings/multi-channels/email')({
  component: Email,
})
